<template>
  <div class="student-detail-card">
      <v-row>
        <v-col cols="4" id="avt">
          <img class="student-avatar" src="/img/avt.png" alt="">
        </v-col>
        <v-col cols="8">
          <div class="d-flex align-center mt-7">
            <div class="student-name" v-if="studentDetail && studentDetail.full_name">
              {{studentDetail.full_name}}
            </div>
            <div v-if="studentDetail && studentDetail.isVip" class="vip-badge">
              VIP
            </div>
          </div>
          <div class="student-code">
            <div>Code: <span v-if="contactUser && contactUser.code">{{contactUser.code}}</span></div>
            <div>Mã học sinh:
              <span v-if="studentId" >{{studentId}}
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      size="small"
                      rounder
                      icon
                      v-on="on"
                      @click="copyLMSCUId(studentId)"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy</span>
                </v-tooltip>
              </span>
            </div>
          </div>
          <div id="advanded" class="d-flex student-code">
            <div class="mt-1 mr-2">Điểm danh:</div>
            <div>
              <div class="d-flex align-center">
                <v-checkbox
                  style="margin-top: 0px"
                  v-model="priority"
                  hide-details
                  label="Ưu tiên"
                  @click="checkPriority()">
                </v-checkbox>
              </div>
              <div class="d-flex align-center">
                <v-checkbox
                  style="margin-top: 0px"
                  v-model="no_call"
                  hide-details
                  label="Không ưu tiên"
                  @click="checkNoCall()">
                </v-checkbox>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="w-100 mt-2">
        <div class="d-flex align-center justify-space-around">
          <template v-for="(item,index) in actions ">
            <div
              v-if="item.permission ? checkAuthorization(item.permission) : true"
              :key="item.key"
  >
              <v-menu offset-y v-if="(item.key === 'call' && contactUser && contactUser.phoneRelated && contactUser.phoneRelated.length )">
                <template v-slot:activator="{ on: menu, attrs }">
                    <div
                      class="d-flex flex-column align-center"
                      v-bind="attrs"
                      v-on="menu"
                    >
                      <img :src="item.img" alt="">
                      <p :class="index === 0 ? 'pt-2 mt-1' : 'mt-1'" style="font-size: 11px">{{item.text}}</p>
                    </div>
                </template>
                <v-list>
                  <v-list-item
                    @click="clickExecuteCall(studentDetail);"
                    class="main-mobile"
                  >
                    <v-list-item-title>{{formatNormalStylePhone(mobileCall)}}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-for="(phone, index) in contactUser.phoneRelated"
                    :key="index"
                    @click="clickExecuteCall(contactUser, phone)"
                    class="sub-mobile"
                  >
                    <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            <div
              v-else
              @click="item.disable ? '' : actionUser(item.key)"
              style="cursor: pointer;">
              <v-tooltip
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="d-flex flex-column align-center"
                    v-bind="attrs"
                    v-on="item.disable ? on : ''"
                  >
                    <img :src="item.img" alt="">
                    <p :class="index === 0 ? 'pt-2 mt-1' : 'mt-1'" style="font-size: 11px">{{item.text}}</p>
                  </div>
                </template>
                <span>Tính năng chưa phát triển</span>
              </v-tooltip>
            </div>
            </div>
          </template>
        </div>
      </div>
      <div style="margin-top: 23px">
        <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-heart-outline</v-icon>
          <div>Ngày sinh: <span v-if="studentDetail && studentDetail.birthday">{{studentDetail.birthday}}</span></div>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-account-supervisor-outline</v-icon>
          <div class="d-flex"> <span class="m-auto pr-2" :style="{width: childCustomers && childCustomers.length ? '60%':'100%'}">Phụ huynh: <span v-if="mainCustomer && mainCustomer.fullName">{{ handleShowParentName(mainCustomer.fullName) }}</span></span>
             <v-select
              v-if="childCustomers && childCustomers.length"
              ref="child-select"
              class="select-child mt-0 w-1-2 custome-child-other"
              @change="changeContactChild()"
              :items="childCustomers"
              :label="`${childCustomers.length} con khác`"
              item-text="fullName"
              item-value="id"
              flat
              hide-details
              dense
              no-data-text="Không có dữ liệu"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="childSelectedId"
            >
            </v-select>
          </div>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-phone</v-icon>
          <div>SĐT:
          <span v-if="mobileCall">{{formatNormalStylePhone(mobileCall)}}
            <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                size="small"
                rounder
                icon
                v-on="on"
                @click="copyLMSCUId(mobileCall)"
                class="ml-2"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip></span></div>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-home-outline</v-icon>
          <div>Đ/c: <span  v-if="mainCustomer">{{contactAddress}}</span></div>
        </div>
        <!-- <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-home-outline</v-icon>
          <div>Trung tâm VH: Hà Đông - Hà Nội</div>
        </div> -->
        <div class="d-flex align-center mb-2">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-right:8px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect width="16" height="16" fill="url(#pattern0)"/>
            <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_8717_11961" transform="scale(0.0625)"/>
            </pattern>
            <image id="image0_8717_11961" width="16" height="16" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQEAQAAADlauupAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAAAqo0jMgAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+cKEwIZMHHULJAAAALSSURBVDjLpZNfSFNxHMXP726awaTFNudy9Oc6771podntj8n+BEKS0DYuGUVojVJQtEAfpLAXKQhKajCkHlpFRIygBkJtZTidD7ZlOMw/K0KinM0Z/qkFivfXQwXSS0Hn9ZyHw/fzPcB/SvG3wM7SjAx1Q36+ZotON/t6dvZPnwBAoS8zc3nZaARYVtHBsrSWZeFlWXQUFdFcjiN1SiUAYHJykrYGg6Shu1sxEAiMVi8tEV5VXk6vt7WRM2VlyNNo/rn7ubk5KrS2Kukxs9ngcjrhAqbu22zkqCThttNJLuv1q/P07vQ0RqJRrEQiaIlGIRgMht137oCrczi47IMH/ziNomCrxcLd83oLUk6nyW00rna5Oq2W23XpUsGA2awkNXo9pru6+FgiQfsCAdQEAkzR8+fjnr4+zrJ+/Vut329y63RCriTJ561WWPfvJ9f0elwYHkZ9KkWsVKlMvKytRUUigauiiH2iSNpKS3Hy40ecTqepOyeH+AoLqSOZxIlHj7Dn4cN4pLd3ZynDLIotLaRgq8VCVJWV2NHZGb+ZSv2uaXIbjcyIKMJit9OLXu/bsXAYkOVf8IjQWFUFAIRX+f1gNRqc3buXimNjaO/tJfZQaOVrKPSueWaG+2C3xzf6/UKjRiO/qajAqcpKOA4cQDgrS47zPOE+t7fH9R0dvGvDBvrJ6SQRScIViwWPGYZWj46S5mQSjowMJNasoS1DQ8iORHAkGoWb5+OHfD4lyVKrN1G1eoJMTQEeD+DxmL7qdAptUxPTND8vHx4clLfFYu9uLSzgyU9CwrfiYvlDebnQ2NNDTO78fMZVX483eXnYPD6OZ0+fxo+/esUN2mzkRiQycSudFoSSEllpteKBzYZvWi0WYzFyv79/pSQYJKv58i5RxFlJot+tVgAga798oeMqFbYPDzMvQqElKRx+n5tM/tOncnWCwG5Zt+5/1/pX/QC35g5T/FvSXwAAAABJRU5ErkJggg=="/>
            </defs>
          </svg>
          <div>Bộ sách chính: <span v-if="studentDetail && studentDetail.books">{{studentDetail.books}}</span></div>
        </div>
        <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-cart-outline</v-icon>
          <div v-if="!totalListOrder" class="loading-dot" style="color: #08F">Đang tải dữ liệu</div>
          <div v-else>Có <span style="color: #4DAF00">{{totalListOrder.length}} đơn hàng</span> <span style="cursor: pointer; color:#1400FF;text-decoration: underline;" @click="showListOrder = true">Chi tiết</span></div>
        </div>
        <!-- <div class="d-flex align-center mb-2">
          <v-icon color="black" small class="mr-2">mdi-cart-outline</v-icon>
          <div>Có <span style="color: #CB0000">2 issues</span> đang xử lí (<a href="">Chi tiết</a>)</div>
        </div> -->
      </div>
      <v-dialog :value="showListOrder" max-width="1100" persistent>
        <order-modal :totalListOrder="totalListOrder" :listTransferOrder="listTransferOrder" :orderList="orderList" @close="showListOrder = false"></order-modal>
      </v-dialog>
  </div>
</template>

<script>
import TokenService from '@/helpers/token';
import * as moment from 'moment';
import {
  TYPE_CALL_STATUS, CHECK_ATTENDANCE_PRIORITY, ORDER_DEPOSIT_TYPE,
  ORDER_FINISH_TYPE, namesOrderContactStatusTc,
} from '@/helpers/constant';
import { mapActions } from 'vuex';
import ContactRepository from '@/services/ContactRepository';
import StudentCareServices from '@/services/StudentCareServices';
import TicketRespository from '@/services/TicketRespository';
import OrderModal from './OrderModal.vue';

export default {
  components: { OrderModal },
  name: 'StudentDetailCard',
  data() {
    return {
      isVip: true,
      activeType: 'all',
      actions: [
        { key: 'call', text: 'Gọi điện', img: '/img/call.png' },
        {
          key: 'zalo', text: 'Gọi Zalo', img: '/img/zalo.png', disable: true,
        },
        { key: 'order', text: 'Tạo đơn hàng', img: '/img/checklist.png' },
        {
          key: 'ticket', text: 'Tạo ticket', img: '/img/pass.png', permission: 'care-submit-ticket_read',
        },
        // {
        //   key: 'planner', text: 'Tạo event', img: '/img/planner.png', disable: true,
        // },
      ],
      priority: false,
      no_call: false,
      CHECK_ATTENDANCE_PRIORITY,
      TYPE_CALL_STATUS,
      selectedContactChild: null, // this.contact.lms_core_user_id,
      recordId: this.$route.params?.id,
      studentDetail: null,
      contactUser: {},
      mainCustomer: {},
      childCustomers: [],
      childSelected: {},
      childSelectedId: null,
      showListOrder: false,
      totalListOrder: null,
      orderList: [],
      listTransferOrder: [],
      contactAddress: '-',
      mobileCall: null,
      studentId: '',
      priorityStatus: 0,
    };
  },
  created() {
    Bus.$on('reload-student-detail-info', () => {
      this.getDetailStudent();
    });
  },
  async mounted() {
    await this.getDetailStudent();
    await this.fetchContactOrders();
  },
  methods: {
    ...mapActions('student_care', ['getCareContactDetail', 'getContactOrder', 'getTransferOrderStudents']),
    ...mapActions('student_detail_bt', ['setStudentBlendedTutor', 'setDataCustomerCode', 'setStudentId']),
    changeViewType(type) {
      this.activeType = type;
    },
    actionUser(key) {
      if (key === 'call') {
        this.clickExecuteCall(this.studentDetail);
        return;
      }
      if (key === 'order') {
        this.createOrder(this.studentDetail.contact_id);
      }
      if (key === 'ticket') {
        const routeData = this.$router.resolve({
          path: '/customer-support',
          query: {
            studentId: this.studentId ? this.studentId : '',
            studentName: this.studentDetail.full_name ? this.studentDetail.full_name : '',
            homeRoomTeacherName: this.studentDetail.homeroom_teacher_name ? this.studentDetail.homeroom_teacher_name : '',
            customerCode: this.contactUser.code ? this.contactUser.code : '',
            module: 'Blended',
          },
        });
        window.open(routeData.href, '_blank');
      }
      if (key === 'todos') {
        Bus.$emit('openModalTriggerTask', null, this.studentDetail);
      }
    },
    checkPriority() {
      if (this.priority) {
        this.no_call = false;
      }
      this.actionChangePriority();
    },
    checkNoCall() {
      if (this.no_call) {
        this.priority = false;
      }
      this.actionChangePriority();
    },
    /* eslint-disable */
    actionChangePriority: _.debounce(async function () {
      const body = {
        lmsCoreUserId: this.studentDetail.lms_core_user_id,
        priorityStatus: 0,
      };
      if (!this.priority && !this.no_call) {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.NO_PRIORITY;
      } else if (this.priority) {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.PRIORITY;
      } else {
        body.priorityStatus = CHECK_ATTENDANCE_PRIORITY.NO_CALL;
      }
      ContactRepository.logAttendance({
        id: this.studentDetail.id,
        oldPriorityStatus: this.priorityStatus,
        priorityStatus: body.priorityStatus,
      });
      const res = await ContactRepository.changePriorityTeacher(body);
      if (!res.success) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res.message ?? 'Có lỗi xảy ra khi tích chọn điểm danh!',
          timer: 3000,
        })
        return;
      }
      this.$swal({
        type: 'success',
        title: 'Cập nhật dữ liệu thành công!',
        timer: 3000,
      })
      this.getPriorityTeacher();
    }, 1000),
    createOrder(contactId) {
      const routeData = `${process.env.VUE_APP_CRM}/contact/contact-list/${contactId}/order-create`;
      window.open(routeData, '_blank');
    },
    clickExecuteCall(dataContact, phone) {
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone ? phone : this.mobileCall,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: null,
          mainMobile: this.mobileCall,
          store: 'T',
          contactCode: this.contactUser.code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    async getStudentId(id) {
      try{
        const response = await TicketRespository.getStudentIdApi(id)
          if(response.success) {
            this.studentId = response.data
            this.setStudentId(this.studentId);
          }else {
            this.studentId = response.data
          }
      } catch (e) {
        console.log(e)
      }
    },
    async getDetailStudent() {
      if (!this.recordId) return;
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'routine',
        attrs: [
          'id', 'contact_id', 'lms_core_user_id', 'student_id', 'full_name', 'customer_id', 'call_id',
          'call_status_id', 'type_customer_care', 'type_curriculum', 'curriculum_id', 'subject_id',
          'subject_id_list', 'mobile', 'code', 'homeroom_teacher_name', 'homeroom_teacher_id',
          'student_product_id',
        ],
        'filters[$eq__id]': this.recordId,
      });
      if( res && res.data && res.data.length) {
        this.studentDetail = res.data[0];
        if (this.studentDetail && (this.studentDetail.type_curriculum == 'online' || this.studentDetail.type_curriculum === 'ielts_course') && this.checkSchoolLevelPermission('create-task-blended_create', 'create-task-blended-secondary_create')) {
          this.actions.push({ key: 'todos', text: 'Tạo công việc', img: '/img/createtask.svg' });
        }
        if(this.studentDetail && this.studentDetail.lms_core_user_id) {
         await this.getStudentId(this.studentDetail.lms_core_user_id)
        }
        this.setStudentBlendedTutor(this.studentDetail);
        this.contactUser = await this.getCareContactDetail(this.studentDetail?.contact_id);
        this.setDataCustomerCode(this.contactUser.code);
        this.mainCustomer = this.contactUser.customers.find((e) => e.isMainCustomer);
        if (this.mainCustomer.ward && this.mainCustomer.province && this.mainCustomer.district) {
          this.contactAddress = `${this.mainCustomer.ward.ten} - ${this.mainCustomer.district.ten} - ${this.mainCustomer.province.ten}`;
        }
        this.studentDetail.birthday = this.contactUser.customers.find((e) => e.id === this.studentDetail.customer_id)?.birthday || '';
          await this.getPersonalBlended({userId:this.studentDetail.lms_core_user_id,contactId:this.studentDetail.contact_id})
          await this.getPriorityTeacher()
        const resPhone = await StudentCareServices.getMobile(this.studentDetail?.id);
        this.mobileCall = resPhone && resPhone.success ? resPhone.data : null;
      } else {
        this.studentDetail = {}
        this.setStudentBlendedTutor(this.studentDetail);
        this.$swal({
          title: 'Lỗi!',
          text: 'Có lỗi xảy ra. Vui lòng thử lại!',
        });
      }
    },
    async getPersonalBlended(params) {
      if(!params) return;
      const res = await StudentCareServices.getPersonalBlended({ userId:params.userId, contactId:params.contactId })
      if(res && res.data) {
        this.childCustomers = res.data.otherChilds.filter(item => item.coreUSerId !== null)
        this.studentDetail.isVip = res.data.isVIP
        this.studentDetail.books = res.data.books
      }
    },
    changeContactChild() {
      this.childSelected = this.childCustomers.find((e) => e.id === this.childSelectedId);
      if(this.childSelected.isBlended) {
        this.routerOtherChild('StudentDetailBlended', null)
      }
      if(!this.childSelected.isBlended && this.childSelected.menu === 'online') {
        this.routerOtherChild('StudentDetailTutor', 'online')
      }
      if(!this.childSelected.isBlended && this.childSelected.menu === 'duo') {
        this.routerOtherChild('StudentDetail', 'duo')
      }
    },
    routerOtherChild(type, key) {
      const params = {
          name: type,
          params: { id: this.childSelectedId },
      }
      if(key) params.query = { typeCurriculum: key }
      const routeData = this.$router.resolve(params);
      window.open(routeData.href, '_blank');
      this.childSelectedId = null;
      this.$refs['child-select'].blur();
    },
    async fetchContactOrders() {
      const result = await this.getContactOrder(this.contactUser?.id);
      if (result && result.data && result.data.length > 0) {
        this.orderList = result.data;
      }
      const res = await this.getTransferOrderStudents(this.contactUser?.id);
      if (res && res.length > 0) {
        this.listTransferOrder = res;
      }
      const totalListOrder = this.orderList.concat(this.listTransferOrder).map((s) => {
        let hasFinishOrder = null;
        let depositLabel = null;
        if (s.isGroupOrder) {
          let depositOrder = s.listOrders.find(item => item.orderType == ORDER_DEPOSIT_TYPE);
          if (depositOrder) {
            s.code = depositOrder.code;
            s.depositOrderId = depositOrder.id;
          }
          hasFinishOrder = s.listOrders.findIndex(e => e.orderType == ORDER_FINISH_TYPE) > -1 ? true : false;
          depositLabel = this.getDepositLabel(s.listOrders);
        }
        if (s && s.created_date) {
          return {
            ...s,
            createdAt: moment(s.created_date).format('YYYY-MM-DD HH:mm:ss'),
            statusOrder: true,
            version: 1,
            hasFinishOrder,
            depositLabel
          };
        } return { ...s, statusOrder: false, hasFinishOrder, depositLabel};
      });
      this.totalListOrder = _.orderBy(totalListOrder, ['createdAt'], ['ASC']).reverse();
    },
    getDepositLabel(listOrder) {
      if (listOrder.every(item => namesOrderContactStatusTc.includes(_.get(item, 'contactStatus.name', '').toUpperCase())) && listOrder.some(item => item.orderType == ORDER_FINISH_TYPE)) {
        return 'Đã hoàn thành phí'
      } else if (listOrder.some(item => namesOrderContactStatusTc.includes(_.get(item, 'contactStatus.name', '').toUpperCase()))) {
        return 'Đã thanh toán 1 phần'
      } else {
        return 'Chưa thanh toán';
      }
    },
    async getPriorityTeacher() {
      const res = await ContactRepository.getPriorityTeacher(this.studentDetail.lms_core_user_id);
      if (!res.success) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res.message ?? 'Có lỗi xảy ra khi lấy trạng thái tích chọn điểm danh!',
          timer: 3000,
        });
        return;
      }
      if (res && res.data) {
        this.priorityStatus = res.data.priority_status;
        if (res.data.priority_status === CHECK_ATTENDANCE_PRIORITY.NO_PRIORITY) {
          this.priority = false;
          this.no_call = false;
        }
        if (res.data.priority_status === CHECK_ATTENDANCE_PRIORITY.PRIORITY) {
          this.priority = true;
          this.no_call = false;
        }
        if (res.data.priority_status === CHECK_ATTENDANCE_PRIORITY.NO_CALL) {
          this.priority = false;
          this.no_call = true;
        }
      }
    },
    copyLMSCUId(id) {
      navigator.clipboard.writeText(id).then(
        () => {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Sao chép thành công!',
            position: 'top',
          });
        },
      );
    },
    formatNormalStylePhone(phone) {
      if (phone) {
        return phone.replace(/(\d{7})(\d{3})$/, 'xxxxxxx$2');
      }
      return '';
    },
  },
  destroyed() {
    this.setStudentBlendedTutor(null);
    Bus.$off('reload-student-detail-info');
  },
};
</script>

<style lang="scss" scoped>
.w-1-2 {
  width: 40%;
}
.type-box {
  font-size: 12px;
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  opacity: 0.6;
  border-radius: 18px;
  cursor: pointer;
}
.active-type-box {
  background: #002CFF !important;
}
.type-box.all {
  background: #5570F1;
}
.type-box.tutor {
  background: #5570F1;
}
.gh-duo{
  font-size: 10px;
  border-radius: 16px ;
  margin-right: 12px;
  background: #67B3DD;
  padding: 8px 16px;
  color: white;
  width: fit-content;
}
.gh-tutor {
  font-size: 10px;
  border-radius: 16px ;
  margin-right: 12px;
  background: #CD91D7;
  padding: 8px 16px;
  color: white;
  width: fit-content;
}
.student-detail-card {
  background: white;
  border-radius: 12px;
  width: 100%;
  padding: 16px;
  margin-top: 15px;
}
.student-avatar {
  border-radius: 50%;
  width: 100%;
}
.student-name {
  font-size: 18px;
  font-weight: bold;
  color: black;
}
.vip-badge{
  background: #27C100;
  border-radius: 4px;
  padding: 4px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  height: 18px;
  color: white;
  font-size: 10px;
  font-weight: bold;
}
.student-code {
  color: #848484;
  font-size: 12px;
}
.loading-dot:after {
  content: ' .';
  animation: dots 1s steps(2, end) infinite;
}

@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: #08F;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 #08F,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 #08F,
      .5em 0 0 #08F;}}
  @media screen and (max-width: 1440px) {
    .student-detail-card {
      font-size: 12px;
      #avt {
        display: flex;
        .student-avatar {
          margin: auto;
        }
      }
      #advanded {
        display: block !important;
        .v-label {
          font-size: 12px !important;
        }
      }
      .student-name {
        font-size: 16px;
      }
    }
  }

</style>
<style lang="scss">
.custome-child-other {
  .v-label {
    color: #1400FF;
  }
}
</style>
